import type { IconType } from 'react-icons';

export type NmMenuIconTone = 'pink' | 'green' | 'cyan' | 'gold' | 'ember' | 'neutral';

interface NmMenuIconProps {
  icon: IconType;
  tone?: NmMenuIconTone;
}

/** Neumorphic raised icon tile for settings / menu rows (replaces emoji). */
export function NmMenuIcon({ icon: Icon, tone = 'pink' }: NmMenuIconProps) {
  return (
    <span className={`nm-menu-row__icon nm-menu-row__icon--${tone}`} aria-hidden>
      <Icon />
    </span>
  );
}
